import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { PdfViewer } from "@/features/documents/components/pdf-viewer";

export const pdfRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/pdf",
  component: PdfViewer,
});
